export enum UserTaskMetadataType {
  checkbox = "checkbox",
  radio = "radio",
  multiCheckbox = "multiCheckbox",
  textarea = "textarea",
  select = "select",
  cascadeselect = "cascadeselect",
  nexguardKey = "nexguardKey",
  nexguardTitle = "nexguardTitle",
  nexguardCustomer = "nexguardCustomer",
  nexguardRecipient = "nexguardRecipient",
  folderControl = "folderControl",
  workflowInstancePerClip = "workflowInstancePerClip",
  galaxyCategory = "galaxyCategory",
  galaxyGlossary = "galaxyGlossary",
  fileControl = "fileControl",
  datePicker = "datePicker",
}
